import { render, staticRenderFns } from "./sign-contract-notice.vue?vue&type=template&id=c5d023bc&scoped=true&"
import script from "./sign-contract-notice.vue?vue&type=script&lang=js&"
export * from "./sign-contract-notice.vue?vue&type=script&lang=js&"
import style0 from "./sign-contract-notice.vue?vue&type=style&index=0&id=c5d023bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d023bc",
  null
  
)

export default component.exports